import React from 'react';
import { withStyles } from 'tss-react/mui';
import parse from 'autosuggest-highlight/parse';
import _match from 'autosuggest-highlight/match';
import { ClassNameMap } from '@mui/material';


export type AutocompleteHighlighterProps = {
  text: string;
  highlight: string;
  classes?: ClassNameMap<'highlight'>;
};


export const AutocompleteHighlighter = withStyles(({ text, highlight, classes }: AutocompleteHighlighterProps) => {
  const matches = React.useMemo(() => {
    return _match(text, highlight, {
      insideWords: true,
    });
  }, [ text, highlight ]);
  const parts = React.useMemo(() => parse(text, matches), [ text, matches ]);

  return (
    <>
      {parts.map((part, idx) =>
        part.highlight ? (
          <span className={classes?.highlight} key={idx}>
            {part.text}
          </span>
        ) : (
          part.text
        )
      )}
    </>
  );
}, theme => ({
  highlight: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  }
}));
